import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pl: {
    translation: {
      nav: {
        home: 'Strona główna',
        about: 'O nas',
        menu: 'Menu',
        events: 'Wydarzenia',
        shop: 'Sklep',
        reservation: 'Rezerwacje'
      },
      hero: {
        welcome: 'Restauracja Tortuga',
        title: 'Gdzie jakość łączy się ze smakiem',
        subtitle: 'Zapraszamy',
        bookTable: 'Zarezerwuj stolik',
        orderDelivery: 'Zamów z Dostawą',
        organizeEvent: 'Organizacja eventów',
        openHours: '12:00 - 22:00',
        location: 'Świnoujście, ul. Uzdrowiskowa 10',
        scrollDown: 'Przewiń w dół',
      },
    
      about: {
        title: 'O nas',
        image1Alt: 'Wnętrze restauracji',
        image2Alt: 'Nasi szefowie kuchni',
        image3Alt: 'Przykładowe danie',
        section1: {
          title: 'Nasza historia',
          description: 'Od ponad 20 lat tworzymy wyjątkowe doznania kulinarne, łącząc tradycję z nowoczesnością.'
        },
        section2: {
          title: 'Nasza kuchnia',
          description: 'Starannie wyselekcjonowane składniki i autorskie przepisy tworzone przez naszych mistrzów kuchni.'
        },
        section3: {
          title: 'Nasz zespół',
          description: 'Pasjonaci gastronomii, dla których gotowanie to nie tylko praca, ale przede wszystkim pasja.'
        }
      },
   
      reservation: {
        title: 'Rezerwacja stolika',
        name: 'Imię i nazwisko',
        namePlaceholder: 'Wprowadź imię i nazwisko',
        email: 'Email (opcjonalnie)',
        emailPlaceholder: 'email@przykład.com',
        date: 'Data',
        time: 'Godzina',
        guests: 'Liczba gości',
        guestsLabel: 'osób',
        selectTime: 'Wybierz godzinę',
        submit: 'Zarezerwuj stolik',
        submitting: 'Rezerwowanie...',
        success: 'Rezerwacja została przyjęta!',
        openHours: 'Restauracja jest czynna w godzinach 12:00 - 22:00',
        requiredFields: 'Pola oznaczone * są wymagane',
        depositInfo: "Wymagana jest zaliczka za rezerwację",
        depositAmount: "Zaliczka: 100 PLN",
        payAndReserve: "Zapłać zaliczkę i zarezerwuj",
        processing: "Przetwarzanie płatności...",
        errors: {
          pastDate: 'Nie można zarezerwować stolika w przeszłości',
          invalidTime: 'Restauracja jest otwarta w godzinach 12:00-22:00',
          invalidEmail: 'Nieprawidłowy format adresu email',
          nameLength: 'Imię i nazwisko musi mieć co najmniej 3 znaki',
          tooManyRequests: 'Zbyt wiele prób rezerwacji. Spróbuj ponownie później',
          connectionError: 'Błąd połączenia. Spróbuj ponownie później',
          reservationClosed: 'Rezerwacje wyłączone ze względu na brak miejsc',
          unknown: 'Wystąpił nieznany błąd'
        }
      },
      footer: {
        contact: 'Kontakt',
        openingHours: 'Godziny otwarcia',
        findUs: 'Znajdź nas',
        address: {
          street: 'ul. Uzdrowiskowa 10',
          city: '72-600 Świnoujście',
          phone: '+48 577 590 180',
          email: 'restauracjatortuga@gmail.com'
        },
        weekdays: 'Poniedziałek - Piątek',
        weekends: 'Sobota - Niedziela',
        copyright: 'Wszelkie prawa zastrzeżone'
      },
        menu: {
          title: "Nasze Menu",
          searchPlaceholder: "Szukaj dań...",
          vegetarian: "Danie wegetariańskie",
          vegan: "Danie wegańskie",
          spicyLevel: "Poziom ostrości",
          glutenFree: "Bez glutenu",
          allergens: "Alergeny",
          noItems: "Brak dań spełniających kryteria",
          noSearchResults: "Nie znaleziono dań pasujących do wyszukiwania",
          title2:'W menu Tortugi każdy znajdzie coś dla siebie.',
          discription: `Serwujemy: Polskie klasyki, które przywołują smaki domowego obiadu, 
            ale w nowoczesnym, zaskakującym wydaniu. Włoskie specjały, takie jak aromatyczne pasty, 
            chrupiące pizze, które zabiorą Cię w podróż po słonecznej Italii. 
            Azjatyckie odkrycia, pełne oryginalnych przypraw, świeżych warzyw 
            i niespotykanych połączeń, idealnych dla tych, którzy szukają kulinarnych przygód.`,
          fullMenu: "Pełne Menu",
          categories: {
            starters: "Przystawki",
            soups: "Zupy",
            mainCourses: "Dania Główne",
            desserts: "Desery",
            drinks: "Napoje"
          },
          common: {
            loading: 'Ładowanie...',
            error: 'Wystąpił błąd',
            retry: 'Spróbuj ponownie',
            close: 'Zamknij',
            back: 'Powrót',
            next: 'Dalej',
            previous: 'Wstecz',
            readMore: 'Czytaj więcej',
            showMore: 'Pokaż więcej',
            showLess: 'Pokaż mniej',
            backToHome: 'Wróć'
          }
        },      
      events: {
        title: 'Wydarzenia',
        subtitle: 'Zorganizuj wyjątkowe wydarzenie',
        description: 'Nasza restauracja to idealne miejsce na organizację różnego rodzaju wydarzeń. Od kameralnych spotkań po duże przyjęcia.',
        upcoming: 'Nadchodzące Wydarzenia',
        past: 'Poprzednie Wydarzenia',
        upcomingEvents: 'Nadchodzące wydarzenia',
        allEvents: 'Wszystkie wydarzenia',
        noEvents: 'Brak wydarzeń do wyświetlenia',
        noUpcomingEvents: 'Brak nadchodzących wydarzeń',
        eventEnded: 'Wydarzenie zakończone',
        registerButton: 'Zapisz się',
        moreInfo: 'Więcej informacji',
        date: 'Data',
        time: 'Godzina',
        price: 'Cena',
        location: 'Lokalizacja',
        availableSlots: 'Dostępne miejsca',
        availablePlaces: 'dostępnych miejsc',
        noSlotsAvailable: 'Brak wolnych miejsc',
        registrationClosed: 'Rejestracja zamknięta',
        contactUs: 'Skontaktuj się z nami',
        everyDay: 'Co',
        nextDate: 'Najbliższy termin',
        backToList: 'Powrót do listy wydarzeń',
        regulations: 'Regulamin',
        recurringInfo: 'To wydarzenie odbywa się co tydzień',
        copyLink: 'Kopiuj link',
        linkCopied: 'Link skopiowany!',
        categories: {
          music: 'Muzyka na żywo',
          tasting: 'Degustacje',
          cooking: 'Warsztaty kulinarne',
          special: 'Wydarzenia specjalne',
          other: 'Inne wydarzenia'
        },
        corporate: {
          title: 'Wydarzenia firmowe',
          description: 'Konferencje, spotkania biznesowe, imprezy integracyjne'
        },
        private: {
          title: 'Przyjęcia prywatne',
          description: 'Urodziny, rocznice, chrzciny, komunie, imprezy w gronie najbliższych'
        },
        registration: {
          title: 'Rejestracja na wydarzenie',
          success: 'Pomyślnie zapisano na wydarzenie',
          error: 'Wystąpił błąd podczas rejestracji',
          confirmButton: 'Potwierdź udział',
          cancelButton: 'Anuluj'
        },
        filters: {
          title: 'Filtry',
          sortBy: 'Sortowanie',
          priceRange: 'Zakres cen'
        },
        details: {
          participants: 'Uczestnicy',
          maxParticipants: 'Maksymalna liczba uczestników',
          organizer: 'Organizator',
          description: 'Opis',
          requirements: 'Wymagania',
          included: 'W cenie',
          additionalInfo: 'Dodatkowe informacje',
          info: 'Informacje',
          notFound: 'Wydarzenie nie zostało znalezione',
          notFoundDesc: 'To wydarzenie nie istnieje lub zostało usunięte.'
        }
      },
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        menu: 'Menu',
        events: 'Events',
        shop: 'Shop',
        reservation: 'Reservations'
      },
      hero: {
        welcome: 'Tortuga Restaurant',
        title: 'Where Quality Meets Taste',
        subtitle: 'Welcome',
        bookTable: 'Book a Table',
        orderDelivery: 'Order Delivery',
        organizeEvent: 'Organize Events',
        openHours: '12:00 - 22:00',
        location: 'Świnoujście, Uzdrowiskowa St. 10',
        scrollDown: 'Scroll Down'
      },
      about: {
        title: 'About Us',
        image1Alt: 'Restaurant Interior',
        image2Alt: 'Our Chefs',
        image3Alt: 'Sample Dish',
        section1: {
          title: 'Our History',
          description: 'For over 20 years, we have been creating unique culinary experiences, combining tradition with modernity.'
        },
        section2: {
          title: 'Our Cuisine',
          description: 'Carefully selected ingredients and original recipes created by our master chefs.'
        },
        section3: {
          title: 'Our Team',
          description: 'Gastronomy enthusiasts for whom cooking is not just work, but above all a passion.'
        }
      },
      reservation: {
        title: 'Table Reservation',
        name: 'Full Name',
        namePlaceholder: 'Enter your full name',
        email: 'Email (optional)',
        emailPlaceholder: 'email@example.com',
        date: 'Date',
        time: 'Time',
        guests: 'Number of Guests',
        guestsLabel: 'people',
        selectTime: 'Select time',
        submit: 'Book Table',
        submitting: 'Booking...',
        success: 'Reservation has been accepted!',
        openHours: 'Restaurant is open from 12:00 to 22:00',
        requiredFields: 'Fields marked with * are required',
        depositInfo: "A deposit is required for reservation",
        depositAmount: "Advance payment: PLN 100",
        payAndReserve: "Pay the deposit and book",
        processing: "Payment processing...",
        errors: {
          pastDate: 'Cannot book a table in the past',
          invalidTime: 'Restaurant is open from 12:00-22:00',
          invalidEmail: 'Invalid email format',
          nameLength: 'Name must be at least 3 characters long',
          tooManyRequests: 'Too many reservation attempts. Please try again later',
          connectionError: 'Connection error. Please try again later',
          unknown: 'An unknown error occurred',
          reservationClosed: 'Reservations disabled due to lack of places',
        }
      },
      footer: {
        contact: 'Contact',
        openingHours: 'Opening Hours',
        findUs: 'Find Us',
        address: {
          street: 'Uzdrowiskowa St. 10',
          city: '72-600 Świnoujście',
          phone: '+48 577 590 180',
          email: 'restauracjatortuga@gmail.com'
        },
        weekdays: 'Monday - Friday',
        weekends: 'Saturday - Sunday',
        copyright: 'All rights reserved'
      },
      menu: {
        title: "Our Menu",
        searchPlaceholder: "Search dishes...",
        vegetarian: "Vegetarian",
        vegan: "Vegan",
        spicyLevel: "Spice Level",
        glutenFree: "Gluten Free",
        allergens: "Allergens",
        noItems: "No dishes match the criteria",
        noSearchResults: "No dishes found matching your search",
        fullMenu: "Full Menu",
        title2: `There's something for everyone on the Tortuga menu.`,
        discription:`We serve: Polish classics that evoke the flavors of a home-cooked meal,

but in a modern, surprising edition. Italian specialties, such as aromatic pastas,

crispy pizzas that will take you on a journey through sunny Italy.

Asian discoveries, full of original spices, fresh vegetables

and unusual combinations, ideal for those looking for culinary adventures.`,
        categories: {
          starters: "Starters",
          soups: "Soups",
          mainCourses: "Main Courses",
          desserts: "Desserts",
          drinks: "Drinks"
        },
        common: {
          loading: 'Loading...',
          error: 'An error occurred',
          retry: 'Try again',
          close: 'Close',
          back: 'Back',
          next: 'Next',
          previous: 'Previous',
          readMore: 'Read more',
          showMore: 'Show more',
          showLess: 'Show less',
          backToHome: 'Return'
        }
      },
      events: {
        title: 'Events',
        subtitle: 'Organize a Special Event',
        description: 'Our restaurant is the perfect place to organize various events. From intimate gatherings to large parties.',
        upcoming: 'Upcoming Events',
        past: 'Past Events',
        upcomingEvents: 'Upcoming Events',
        allEvents: 'All Events',
        noEvents: 'No events to display',
        noUpcomingEvents: 'No upcoming events',
        eventEnded: 'Event ended',
        registerButton: 'Register',
        moreInfo: 'More Information',
        date: 'Date',
        time: 'Time',
        price: 'Price',
        location: 'Location',
        availableSlots: 'Available Slots',
        availablePlaces: 'available places',
        noSlotsAvailable: 'No slots available',
        registrationClosed: 'Registration closed',
        contactUs: 'Contact us',
        everyDay: 'Every',
        nextDate: 'Next date',
        backToList: 'Back to events list',
        regulations: 'Regulations',
        recurringInfo: 'This event takes place every week',
        copyLink: 'Copy link',
        linkCopied: 'Link copied!',
        categories: {
          music: 'Live Music',
          tasting: 'Tastings',
          cooking: 'Cooking Workshops',
          special: 'Special Events',
          other: 'Other Events'
        },
        corporate: {
          title: 'Corporate Events',
          description: 'Conferences, business meetings, team building events'
        },
        private: {
          title: 'Private Events',
          description: 'Birthdays, anniversaries, baptisms, communions, events with loved ones'
        },
        registration: {
          title: 'Event Registration',
          success: 'Successfully registered for the event',
          error: 'An error occurred during registration',
          confirmButton: 'Confirm Participation',
          cancelButton: 'Cancel'
        },
        filters: {
          title: 'Filters',
          sortBy: 'Sort by',
          priceRange: 'Price Range'
        },
        details: {
          participants: 'Participants',
          maxParticipants: 'Maximum number of participants',
          organizer: 'Organizer',
          description: 'Description',
          requirements: 'Requirements',
          included: 'Included in price',
          additionalInfo: 'Additional Information',
          info: 'Information',
          notFound: 'Event not found',
          notFoundDesc: 'This event does not exist or has been removed.'
        }
      },
    }
  },
  de: {
    translation: {
      nav: {
        home: 'Startseite',
        about: 'Über uns',
        menu: 'Speisekarte',
        events: 'Veranstaltungen',
        shop: 'Shop',
        reservation: 'Reservierungen'
      },
      hero: {
        welcome: 'Restaurant Tortuga',
        title: 'Wo Qualität auf Geschmack trifft',
        subtitle: 'Willkommen',
        bookTable: 'Tisch reservieren',
        orderDelivery: 'Lieferung bestellen',
        organizeEvent: 'Veranstaltungen organisieren',
        openHours: '12:00 - 22:00',
        location: 'Świnoujście, Uzdrowiskowa Str. 10',
        scrollDown: 'Nach unten scrollen'
      },
      about: {
        title: 'Über uns',
        image1Alt: 'Restaurant-Interieur',
        image2Alt: 'Unsere Köche',
        image3Alt: 'Beispielgericht',
        section1: {
          title: 'Unsere Geschichte',
          description: 'Seit über 20 Jahren schaffen wir einzigartige kulinarische Erlebnisse und verbinden Tradition mit Moderne.'
        },
        section2: {
          title: 'Unsere Küche',
          description: 'Sorgfältig ausgewählte Zutaten und originelle Rezepte, kreiert von unseren Meisterköchen.'
        },
        section3: {
          title: 'Unser Team',
          description: 'Gastronomie-Enthusiasten, für die das Kochen nicht nur Arbeit, sondern vor allem Leidenschaft ist.'
        }
      },
      reservation: {
        title: 'Tischreservierung',
        name: 'Vollständiger Name',
        namePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
        email: 'E-Mail (optional)',
        emailPlaceholder: 'email@beispiel.com',
        date: 'Datum',
        time: 'Uhrzeit',
        guests: 'Anzahl der Gäste',
        guestsLabel: 'Personen',
        selectTime: 'Uhrzeit auswählen',
        submit: 'Tisch buchen',
        submitting: 'Buchung...',
        depositInfo: "Für die Reservierung ist eine Anzahlung erforderlich",
        depositAmount: "Anzahlung: 100 PLN",
        payAndReserve: "Anzahlung leisten und buchen",
        processing: "Zahlungsabwicklung...",
        success: 'Reservierung wurde angenommen!',
        openHours: 'Restaurant ist von 12:00 bis 22:00 Uhr geöffnet',
        requiredFields: 'Mit * markierte Felder sind Pflichtfelder',

        errors: {
          pastDate: 'Keine Reservierung in der Vergangenheit möglich',
          invalidTime: 'Restaurant ist von 12:00-22:00 Uhr geöffnet',
          invalidEmail: 'Ungültiges E-Mail-Format',
          nameLength: 'Name muss mindestens 3 Zeichen lang sein',
          tooManyRequests: 'Zu viele Reservierungsversuche. Bitte versuchen Sie es später erneut',
          connectionError: 'Verbindungsfehler. Bitte versuchen Sie es später erneut',
          unknown: 'Ein unbekannter Fehler ist aufgetreten',
          reservationClosed: 'Reservierungen aufgrund fehlender Plätze deaktiviert',
        }
      },
      footer: {
        contact: 'Kontakt',
        openingHours: 'Öffnungszeiten',
        findUs: 'Finden Sie uns',
        address: {
          street: 'Uzdrowiskowa Str. 10',
          city: '72-600 Świnoujście',
          phone: '+48 577 590 180',
          email: 'restauracjatortuga@gmail.com'
        },
        weekdays: 'Montag - Freitag',
        weekends: 'Samstag - Sonntag',
        copyright: 'Alle Rechte vorbehalten'
      },
      menu: {
        title: "Unsere Speisekarte",
        searchPlaceholder: "Gerichte suchen...",
        vegetarian: "Vegetarisch",
        vegan: "Vegan",
        spicyLevel: "Schärfegrad",
        glutenFree: "Glutenfrei",
        allergens: "Allergene",
        noItems: "Keine Gerichte entsprechen den Kriterien",
        noSearchResults: "Keine Gerichte gefunden, die Ihrer Suche entsprechen",
        fullMenu: "komplettes Menü",
        title2:`Auf der Speisekarte von Tortuga findet jeder etwas für sich.`,
        discription:`Wir servieren: Polnische Klassiker, die an die Aromen eines hausgemachten Abendessens erinnern,
 aber in einer modernen, überraschenden Version. Italienische Spezialitäten wie aromatische Pasten,
 knusprige Pizzen, die Sie auf eine Reise durch das sonnige Italien entführen.
 Asiatische Entdeckungen, voller origineller Gewürze und frischem Gemüse
 und ungewöhnliche Kombinationen, perfekt für alle, die kulinarische Abenteuer suchen.`,
        categories: {
          starters: "Vorspeisen",
          soups: "Suppen",
          mainCourses: "Hauptgerichte",
          desserts: "Desserts",
          drinks: "Getränke"
        },
        common: {
          loading: 'Wird geladen...',
          error: 'Ein Fehler ist aufgetreten',
          retry: 'Erneut versuchen',
          close: 'Schließen',
          back: 'Zurück',
          next: 'Weiter',
          previous: 'Zurück',
          readMore: 'Mehr lesen',
          showMore: 'Mehr anzeigen',
          showLess: 'Weniger anzeigen',
          backToHome: 'Komm zurück'
        }
      },
      events: {
        title: 'Veranstaltungen',
        subtitle: 'Organisieren Sie eine besondere Veranstaltung',
        description: 'Unser Restaurant ist der perfekte Ort für verschiedene Veranstaltungen. Von intimen Zusammenkünften bis hin zu großen Feiern.',
        upcoming: 'Kommende Veranstaltungen',
        past: 'Vergangene Veranstaltungen',
        upcomingEvents: 'Kommende Veranstaltungen',
        allEvents: 'Alle Veranstaltungen',
        noEvents: 'Keine Veranstaltungen anzuzeigen',
        noUpcomingEvents: 'Keine kommenden Veranstaltungen',
        eventEnded: 'Veranstaltung beendet',
        registerButton: 'Registrieren',
        moreInfo: 'Weitere Informationen',
        date: 'Datum',
        time: 'Uhrzeit',
        price: 'Preis',
        location: 'Ort',
        availableSlots: 'Verfügbare Plätze',
        availablePlaces: 'verfügbare Plätze',
        noSlotsAvailable: 'Keine Plätze verfügbar',
        registrationClosed: 'Anmeldung geschlossen',
        contactUs: 'Kontaktieren Sie uns',
        everyDay: 'Jeden',
        nextDate: 'Nächster Termin',
        backToList: 'Zurück zur Veranstaltungsliste',
        regulations: 'Reglement',
        recurringInfo: 'Diese Veranstaltung findet wöchentlich statt',
        copyLink: 'Link kopieren',
        linkCopied: 'Link kopiert!',
        categories: {
          music: 'Live-Musik',
          tasting: 'Verkostungen',
          cooking: 'Kochworkshops',
          special: 'Spezielle Veranstaltungen',
          other: 'Andere Veranstaltungen'
        },
        corporate: {
          title: 'Firmenveranstaltungen',
          description: 'Konferenzen, Geschäftstreffen, Teambuilding-Events'
        },
        private: {
          title: 'Private Veranstaltungen',
          description: 'Geburtstage, Jubiläen, Taufen, Kommunionen, Veranstaltungen mit Ihren Lieben'
        },
        registration: {
          title: 'Veranstaltungsregistrierung',
          success: 'Erfolgreich für die Veranstaltung registriert',
          error: 'Ein Fehler ist bei der Registrierung aufgetreten',
          confirmButton: 'Teilnahme bestätigen',
          cancelButton: 'Abbrechen'
        },
        filters: {
          title: 'Filter',
          sortBy: 'Sortieren nach',
          priceRange: 'Preisbereich'
        },
        details: {
          participants: 'Teilnehmer',
          maxParticipants: 'Maximale Teilnehmerzahl',
          organizer: 'Organisator',
          description: 'Beschreibung',
          requirements: 'Anforderungen',
          included: 'Im Preis enthalten',
          additionalInfo: 'Zusätzliche Informationen',
          info: 'Informationen',
          notFound: 'Veranstaltung nicht gefunden',
          notFoundDesc: 'Diese Veranstaltung existiert nicht oder wurde entfernt.'
        }
      },
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl', // Zmiana na 'pl' jako podstawowy fallback
    supportedLngs: ['pl', 'en', 'de'], // Dodajemy listę wspieranych języków
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true
    },
    interpolation: {
      escapeValue: false
    }
  });

  export const setFallbackLanguage = (lang) => {
    i18n.options.fallbackLng = lang;
  };

export default i18n;